module.exports = __webpack_public_path__ + "static/media/Maf_AsesoriaPolitica_Home.a37a7f2b.jpg";